import { useState, useCallback } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import RateCard from "@/components/site/RateCard";
import Marquee from "@/components/site/Marquee";
import Calculator from "@/components/site/Calculator";
import Manifesto from "@/components/site/Manifesto";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import ContactForm from "@/components/site/ContactForm";
import FloatingButtons from "@/components/site/FloatingButtons";
import QuoteDialog from "@/components/site/QuoteDialog";
import Footer from "@/components/site/Footer";
import SmoothScroll from "@/lib/SmoothScroll";

const MARQUEE_ITEMS = [
  "Repainting Only",
  "Flat BHK Pricing",
  "Asian Paints",
  "Berger",
  "Dulux",
  "Free Site Visit",
  "On-Time Delivery",
  "Bangalore",
];

export default function Home() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [prefill, setPrefill] = useState(null);

  const openQuote = useCallback((p = null) => {
    setPrefill(p);
    setQuoteOpen(true);
  }, []);

  const scrollToCalculator = () => {
    const el = document.getElementById("calculator");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <main data-testid="home-page" className="min-h-screen bg-[rgb(var(--page))]">
      <SmoothScroll />
      <Navbar onGetQuote={() => openQuote()} />
      <Hero onGetQuote={() => openQuote()} onCalculate={scrollToCalculator} />
      <Services />
      <RateCard onGetQuote={() => openQuote()} />
      <Marquee items={MARQUEE_ITEMS} speed={40} />
      <Calculator onRequestQuote={(data) => openQuote(data)} />
      <Manifesto />
      <Gallery />
      <Testimonials />
      <FAQ />
      <ContactForm />
      <Footer />
      <FloatingButtons />
      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} prefill={prefill} />
    </main>
  );
}
